<template>
  <v-tooltip :disabled="!tag.description" bottom>
    <template #activator="{ on, attrs }">
      <div
        class="tag_container"
        :style="tagStyle"
        v-bind="attrs"
        v-on="on"
      >
        <span>{{ tag.label }}</span>
        <BaseIcon
          v-if="closable"
          icon="$mdiClose"
          x-small
          class="close"
          @click.stop="$emit('close', tag)"
        />
      </div>
    </template>
    <span>{{ tag.description }}</span>
  </v-tooltip>
</template>



<script>
import BaseIcon from "@/core/Components/UI/Icon/BaseIcon.vue";

export default {
  name: "OrganizationTag",
  components: {
    BaseIcon,
  },
  props: {
    tag: {
      type: Object,
      required: true,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tagStyle() {
      return {
        backgroundColor: this.tag.color,
      };
    },
  },
};
</script>



<style lang="scss" scoped>
.tag_container {
  height: 26px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #ecebf1;
  border-radius: 6px;
  padding: 0px 6px;

  span {
    font-size: 10pt;
  }

  .close {
    cursor: pointer;
  }
}
</style>
